// extracted by mini-css-extract-plugin
export var bold = "_rb-0";